import dic from "./dic/index";

const modules = {
  dic,
}

export default modules;